import { render } from "./pc.vue?vue&type=template&id=2d73805a"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"

import "./pc.vue?vue&type=style&index=0&id=2d73805a&lang=css"

import exportComponent from "/Users/zqj/Documents/git/H5/Website/WaterHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__